import { agencyParameterTemplateOverview } from '@app/pcs/models/agency-parameter-template';
import { gql } from 'apollo-angular';

export const deleteTrainParameterTemplatesMutation = gql`
  mutation DeleteTrainParameterTemplates($templateIds: [Long]!) {
    deleteTrainParameterTemplates(templateIds: $templateIds) {
      ...agencyParameterTemplateOverview
    }
  }
  ${agencyParameterTemplateOverview}
`;

export const saveTrainParametersTemplateMutation = gql`
  mutation SaveTrainParametersTemplate($template: AgencyParameterTemplateInput!,
    $trainParameters: TrainParametersInput!) {
    saveTrainParametersTemplate (template: $template, trainParameters: $trainParameters) {
      ...agencyParameterTemplateOverview
    }
  }
  ${agencyParameterTemplateOverview}
`;
